import { render, staticRenderFns } from "./GlassDamagesQuestion.vue?vue&type=template&id=ab97ac52&scoped=true"
import script from "./GlassDamagesQuestion.vue?vue&type=script&lang=ts"
export * from "./GlassDamagesQuestion.vue?vue&type=script&lang=ts"
import style0 from "./GlassDamagesQuestion.vue?vue&type=style&index=0&id=ab97ac52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab97ac52",
  null
  
)

export default component.exports